import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "assets/translations/widgetTranslationsLionsbridge"

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'en_US',
    resources,
    lng: "en_US",

    keySeparator: false, // we do not use keys in form messages.welcome
    react: {
      wait: true
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: function (value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      }
    }
  });

export default i18n;